import { DaperClient } from "@data/daper-client";
import { DaperImagesBulkParams } from "@data/daper-client/types";

import { wrapResponse } from "./wrapResponse";

async function getImagesBulkHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as DaperImagesBulkParams;

  const daperClient = DaperClient.init({
    host: process.env.DAPER_URL,
    username: process.env.DAPER_USERNAME,
    password: process.env.DAPER_PASSWORD,
  });

  const daperResponse = await daperClient.getImagesBulk(params);

  return res.status(200).json(daperResponse);
}

export default getImagesBulkHandler;
